module.exports = __webpack_public_path__ + "static/img/tube_header_alt.b70bb67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tube_header_alt.jpg
// module id = iZnx
// module chunks = 0